var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{staticClass:"component--tag",attrs:{"closable":_vm.closable},on:{"close":_vm.handleClose}},[_c('span',{ref:"compareRef",staticClass:"compare-ref-class"}),_c('span',{ref:"contentWrapper",staticClass:"content-wrapper",style:({'max-width':_vm.contentMaxWidth+'px'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }